import React from 'react'

import styles from './Item.module.css'

type ItemProps = {
  value: string
  onClick: () => void
}

const Item = ({ value, onClick }: ItemProps): JSX.Element => (
  <div className={styles.item}>
    <a
      className={styles.itemLink}
      onClick={(event) => {
        event.preventDefault()
        onClick()
      }}
    >
      {value}
    </a>
  </div>
)

export default Item
